var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRecordUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8D26\\u6237\\u8BB0\\u5F55",
    transform: "translate(-56.000000, -226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9",
    transform: "translate(56.000000, 226.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0.1,
    fill: "#474CE2",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25,12.75 L44.25,19.5 L33.75,19.5 L33.7505101,24.8250343 C42.3086572,25.1725265 48.75,26.6858176 48.75,28.5 C48.75,30.3141584 42.3088276,31.8274335 33.7508497,32.1749519 L33.75,47.25 L26.25,47.25 L26.2501481,32.1749924 C17.6916731,31.8275511 11.25,30.3142289 11.25,28.5 C11.25,26.6857711 17.6916731,25.1724489 26.2501481,24.8250076 L26.25,19.5 L15.75,19.5 L15.75,12.75 L44.25,12.75 Z M33.7509931,25.5749019 L33.75,29.25 L26.25,29.25 L26.2500048,25.5748612 C19.3619862,25.8552512 14.25,26.8906283 14.25,28.125 C14.25,29.5747475 21.3015152,30.75 30,30.75 C38.6984848,30.75 45.75,29.5747475 45.75,28.125 C45.75,26.8906879 40.6385075,25.8553512 33.7509931,25.5749019 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#3A78F6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecordUsdt);
export default __webpack_public_path__ + "static/media/icon_record_usdt.81a23b2f01e32c9b65d76c30a1943998.svg";
export { ForwardRef as ReactComponent };